import styled from 'styled-components';

interface IDropdown {
  marginTop?: number;
  state?: boolean;
}

export const Container = styled.div<IDropdown>`
  display: flex;
  flex-direction: column;
  background-color: #FFFFFF;
  max-height: ${({state}) => `${state === true? '':'6.25rem'}`};
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  gap: 4.125rem;
  width: 95%;
  padding: 2rem 5.5rem;
  cursor: pointer;
  margin-top: ${({marginTop}) => `${marginTop? `${marginTop}rem`:''}`};
  transition: ease max-height .3s;
  &.show {
    transition: max-height 1s;
    max-height: 125rem;
  }
  @media (max-width: 840px){
    width: 100%;
  }
`;

export const InitialContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Content = styled.span`
  font-size: 1.75rem;
  line-height: 2.25rem;
  color: #272848;
`;

export const IconContainer = styled.div`
`;

export const Icon = styled.img`
  width: 1.6875rem;
  transition: ease transform .3s;
  &.flip {
    transform: rotate(180deg);
    margin-left: 1px;
  }
`;

export const HiddenContent = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 1.5rem;
  line-height: 2.25rem;
  color: #666666;
  overflow-y: auto;
`;